import type { ClinicalInsightDateRange } from "src-next/modules/clinical-insights/types/analysisTypes";
import type { LoadPhase } from "src-next/modules/clinical-insights/loadPhase";
import { processEntriesToProblems, type ProblemData } from "src-next/modules/clinical-insights/transformers/processProblemEntries";
import { useQrClinicalRegisterAnalysis } from "./useQrClinicalRegisterAnalysis";

function getProblemPatientIds(records: ProblemData[]): string[] {
  return records.map((p) => p.patientId);
}

interface Args {
  author: string;
  practitionerFilter: string;
  dateRange?: ClinicalInsightDateRange;
  getPractitionerName: (ref: string) => string;
  onLoadPhaseChange?: (phase: LoadPhase) => void;
  fetchEnabled?: boolean;
}

export function useProblemListAnalysisData(args: Args) {
  return useQrClinicalRegisterAnalysis<ProblemData>({
    ...args,
    processEntries: processEntriesToProblems,
    getPatientIds: getProblemPatientIds,
  });
}
